const resolveBool = ({ rawVal }: any) => {
  return /boolean/.test(typeof rawVal) ? rawVal : /^on$/i.test(rawVal);
};

export default resolveBool;
